import { render, staticRenderFns } from "./scretch.vue?vue&type=template&id=4ad36322&scoped=true&"
import script from "./scretch.vue?vue&type=script&lang=js&"
export * from "./scretch.vue?vue&type=script&lang=js&"
import style0 from "./scretch.vue?vue&type=style&index=0&id=4ad36322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad36322",
  null
  
)

export default component.exports